<template>
  <div class="flex space_between _navSearchBar">
    <div class="left" @click="onNavLeft" v-if="iconShow">
      <van-icon name="arrow-left" color="white" size=".5rem"/>
    </div>
    <div class="title">{{ title }}</div>
    <van-search placeholder="请输入搜索关键词" shape="round" :background="m_color" style="width: 100%" @click="$router.push('/common/search')">
    </van-search>
  </div>
</template>
<script>
export default {
  name: "navSearchBar",
  props: {
    iconShow: {type:Boolean,default:true},//是否显示左边图标
    title: {type: String, default: '标题'}, //标题
  },
  data() {
    return {}
  },
  methods: {
    //点击左侧
    onNavLeft() {
      history.go(-1)
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/navSearchBar.vue